export default {
  namespaced: true,
  state: {
    initialConfOptions: [{
        text: "Puertas",
        text2: "activityCentre.doors",
        icon: "open_in_browser",
        options: [{
          text: "Añadir al menos una puerta",
          text2: "activityCentre.dDesc1",
          check: true,
          icon: "library_add",
        }]
      },
      {
        text: "Niveles",
        text2: "activityCentre.levels",
        icon: "flag",
        options: [{
            text: "Añadir al menos un Nivel",
            text2: "activityCentre.lDesc1",
            check: true,
            icon: "library_add",
          },
          {
            text: "Ligar al menos una puerta a un nivel",
            text2: "activityCentre.lDesc2",
            check: true,
            icon: "link",
          },
          {
            text: "Añadir al menos un grado y grupo a un nivel",
            text2: "activityCentre.lDesc3",
            check: true,
            icon: "library_add",
          }
        ]
      },
      {
        text: "Colaboradores",
        text2: "activityCentre.employee",
        icon: "work",
        options: [{
          text: "Añadir al menos un colaborador",
          text2: "activityCentre.eDesc1",
          check: true,
          icon: "library_add",
        }]
      },
      {
        text: "Alumnos",
        text2: "activityCentre.students",
        icon: "school",
        options: [{
            text: "Añadir al menos un alumno",
            text2: "activityCentre.sDesc1",
            check: true,
            icon: "library_add",
          },
          {
            text: "Ligar al menos un alumno a un tutor",
            text2: "activityCentre.sDesc2",
            check: true,
            icon: "link",
          },
        ]
      },
      {
        text: "Tutores",
        text2: "activityCentre.parents",
        icon: "person",
        options: [{
          text: "Añadir al menos un tutor",
          text2: "activityCentre.pDesc1",
          check: true,
          icon: "library_add",
        }, {
          text: "Añadir al menos un código QR de familiar",
          text2: "activityCentre.pDesc2",
          check: true,
          icon: "library_add",
        }, {
          text: "Ligar al menos un tutor con un alumno",
          text2: "activityCentre.pDesc3",
          check: true,
          icon: "link",
        }]
      },
      {
        text: "Dispositivos",
        text2: "activityCentre.devices",
        icon: "devices_other",
        options: [{
          text: "Añadir al menos un dispositivo Ipad y un dispositivo Único",
          text2: "activityCentre.devDesc1",
          check: true,
          icon: "library_add",
        }]
      }
    ],
    alerts: []
  },
  mutations: {
    updateConfOptions(state, payload) {
      state.initialConfOptions[payload.index].options[payload.index2].check = payload.check;
    },
    updateAlerts(state, payload) {
      state.alerts = payload.alerts;
    }
  },
  getters: {
    getMenuItems: state => {
      return state.initialConfOptions
    },
    getAlerts: state => {
      return state.alerts;
    }
  }
}